import { connect, MapStateToProps } from 'react-redux';
import { ModuleType } from '../../../../types/modules';
import { getModuleIdByModuleType } from '../../../selectors/modules';
import { Props } from './GroupChangeFounderModal';

export type StateProps = Pick<Props, 'moduleId'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => ({
  moduleId: getModuleIdByModuleType(state, ModuleType.GROUP_RECRUITMENT),
});

export default connect(mapStateToProps);
